module.exports = __webpack_public_path__ + "static/design-lace-up.0669d75a.svg";